import React from "react";
import ReactTooltip from "react-tooltip";

const ToolTip = (props) => {
  return (
    <div>
      <p>
        {props.activeWords.map((activeWord, index) => {
          return (
            <span key={activeWord}>
              {props.beforeContent[index]}
              {
                props.tooltips[index] === "BOLD" ? (
                  <strong key={index}>{activeWord}</strong>
                ) : (
                    <a data-tip data-for={activeWord}>
                      <b><u>{activeWord}</u></b>
                    </a>
                  )
              }
              {props.afterContent[index]}
            </span>
          )
        })}
      </p>
      {props.activeWords.map((activeWord, index) => {
        return props.tooltips[index] !== "BOLD" && (
          <ReactTooltip
            key={`t_${activeWord}`}
            id={activeWord}
            type="dark"
            html={true}
          >
            {props.tooltips[index]}
          </ReactTooltip>
        );
      })}
    </div>
  );
};

export default ToolTip;
